import React from "react";
import cx from "classnames";
import { CloseIcon } from "@picklebet/ui";

import * as styles from "@/features/betslip/components/parts/RemoveButton.module.scss";

type RemoveButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
};

export const RemoveButton = ({
  onClick,
  disabled,
  testId,
}: RemoveButtonProps) => (
  <button
    type="button"
    aria-label="Remove selection"
    onClick={disabled ? undefined : onClick}
    className={cx(styles.remove, { [styles.hidden]: disabled })}
    data-testid={testId}
  >
    <CloseIcon />
  </button>
);
